import React, { useEffect, useState } from "react";
import Modal from "../../../../components/modal";
import moment from "moment";

const PurchasePushedApprove = ({ show, onClose, heading, initialData = {} }) => {
    console.log(initialData);

    const [products, setProducts] = useState([]);

    useEffect(() => {
        if (initialData) {
            if (initialData.pushedForPurchase) {
                setProducts(initialData.pushedForPurchase);
            }
        }
    }, [initialData]);

    const handleVendorChange = (productIndex, vendorId) => {
        const updatedProducts = [...products];
        const selectedVendor = updatedProducts[productIndex].RawProductVendors.find(vendor => vendor.vendor_id === vendorId);
        updatedProducts[productIndex].selectedVendor = selectedVendor;
        setProducts(updatedProducts);
    };

    const handleQuantityChange = (productIndex, quantity) => {
        const updatedProducts = [...products];
        updatedProducts[productIndex].quantity = quantity;
        setProducts(updatedProducts);
    };


    const calculateRequired = (vendorsData) => {
        let requiredQty = 0;
        let totalQty = 0;
        vendorsData?.RawProductVendors?.map((e) => {
            totalQty += e.quantity;
        });

        const finalPo = initialData.finalProduct.finalRawProducts.find((f) => f.raw_product_id === vendorsData.id);
        console.log('final prod', finalPo);
        if (finalPo) {
            requiredQty = (initialData.quantity * finalPo.quantity) - totalQty;
        }

        if (requiredQty > 0) {
            return requiredQty;
        }
        return 0;

    };

    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-12 mb-2">
                        <h5>Company Name: {initialData?.customer?.company_name}</h5>
                    </div>
                    <div className="col-md-6 mb-2">
                        <h6>Customer Name: {initialData?.customer?.name}</h6>
                    </div>
                    <div className="col-md-6 mb-2">
                        <h6>Customer Email: {initialData?.customer?.email}</h6>
                    </div>
                    <div className="col-md-6 mb-2">
                        <h6>Customer Phone: {initialData?.customer?.phone}</h6>
                    </div>
                    <div className="col-md-6 mb-2">
                        <h6>Delivery Date: {moment(initialData?.date).format('DD MMMM, YYYY')}</h6>
                    </div>
                </div>
            </div>
            <div className="col-md-12 pb-3">
                <h4 className="mb-3 mt-3">Required Products</h4>
                <hr></hr>
                {products && products.map((product, index) => (
                    calculateRequired(product.products) > 0 ? (
                        <div className="row" key={index}>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label">Product</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        readOnly
                                        value={product.products?.name || ""}
                                    />
                                </div>
                            </div>

                            {/* Quantity */}
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label">Quantity</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="quantity"
                                        readOnly
                                        value={calculateRequired(product.products)}

                                    />
                                </div>
                            </div>
                        </div>
                    ):('None')
                ))}
            </div>
        </Modal>
    );
};

export default PurchasePushedApprove;
